@if (!textCols) {
<div class="p-flex p-flex-center p-h-full">
  <p-progress-spinner-lg />
</div>
} @if (corpus && columnProps && textCols) {
<div class="p-stack--row p-h-full p-max-h-full p-overflow-hidden">
  <div class="p-stack format-toolbar">
    <div class="p-flex p-flex-col p-flex-grow-1 p-min-h-0 p-overflow-auto">
      <div class="p-flex-row-xs p-flex-center-y p-p-xxs">
        <p-button-icon-ghosted-lg icon="arrow-left" aria-label="Back" (click)="back.emit()" />
        <span class="p-text-body">Format data</span>
      </div>
      <div class="p-divider"></div>
      <div class="p-content p-content--md p-flex-col-xxs">
        <span class="p-text-desc">Column you wish to model<span class="p-color-error">*</span></span>
        <p-select-lg
          trackBy="colId"
          placeholder="Select content"
          [options]="textCols"
          [ngModel]="service.contentCol"
          (ngModelChange)="setContentCol($event)"
        />
      </div>
      <div class="p-divider"></div>
      <div class="p-content p-content--md p-flex-col-md">
        <span class="p-text-body">Configure metadata</span>

        <app-mapping
          [mapping]="(service.mapping$ | async) ?? undefined"
          [columnMeta]="corpus.columnMeta"
          [columnProps]="columnProps"
          [editable]="true"
          (mappingChange)="mappingChanged($event)"
        ></app-mapping>
      </div>
    </div>

    <div class="p-content p-content--md">
      <p-button-primary class="p-w-full" [loading]="isSaving" [disabled]="!canSave()" (click)="save()">
        Save & analyze
      </p-button-primary>
    </div>
  </div>

  <div class="p-divider"></div>

  <app-data-grid [dataService]="gridDataService" [rendererProvider]="gridRenderer" [editable]="false"></app-data-grid>
</div>
}
